<template>
  <main class="tryout-app">
    <section class="tryout-app__header">
      <h2 class="tryout-app__title">My Tryouts</h2>
    </section>

    <section class="tryout-app__list">
      <p v-if="tryouts.length === 0">No tryouts added yet.</p>
      <div v-for="tryout in tryouts" :key="tryout.id" class="tryout-app__item">
        <tryout-app-item class="tryout-app__tryout" v-bind="tryout" />
        <app-button text @click="remove(tryout.id)">
          <app-icon variant="delete" />
        </app-button>
      </div>
    </section>
  </main>
</template>

<script>
import AppButton from '@/components/AppButton.vue'
import AppIcon from '@/components/AppIcon.vue'
import TryoutAppItem from '@/components/TryoutAppItem.vue'

export default {
  components: {
    AppButton,
    AppIcon,
    TryoutAppItem,
  },
  computed: {
    tryouts() {
      return this.$store.state.tryout.tryouts
    },
  },
  methods: {
    remove(id) {
      this.$store.dispatch('tryout/remove', id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.tryout-app {
  margin: auto;
  max-width: 512px;
  width: 90vw;

  &__header {
    padding: 1rem 0;
  }

  &__item {
    display: flex;
  }

  &__title {
    font-weight: 100;
    font-size: max(3vw, 2rem);
    padding: 1rem 0;
  }

  &__tryout {
    flex: 1;
  }
}
</style>
